import { IBalanceHistory } from "../types/balanceHistory.types";

export const BALANCE_HISTORY_INITIAL_STATE: IBalanceHistory = {
  history: [],
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  transactionHistory: [],
  loading: false,
  selectedItem: null,
};
